<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Training Event Report
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer> -->
        <div class="ml-12">
          <download-excel
              :data="selected"
              :fields="export_fields"
              name="trainingEventReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="registrationReport.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="registrationReport.count"
          class="elevation-1"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="pb-2 px-4" row wrap>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="programTypeValue"
                  :clearable="clearable"
                  :items="PROGRAM_TYPES"
                  :loading="programTypeLoading"
                  item-text="name"
                  item-value="id"
                  label="CPD Activity Type"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="activityDeliveryValue"
                  :clearable="clearable"
                  :items="ACTIVITY_DELIVERIES"
                  :loading="activityDeliveryLoading"
                  item-text="name"
                  item-value="id"
                  label="Activity Delivery"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="cpdActivityValue"
                  :clearable="clearable"
                  :items="CATEGORIES"
                  :loading="cpdALoading"
                  item-text="name"
                  item-value="id"
                  label="CPD Activity"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="cpdProviderValue"
                  :clearable="clearable"
                  :items="CPD_PROVIDERS"
                  :loading="cpdProviderLoading"
                  item-text="trainingCenterName"
                  item-value="id"
                  label="CPD Provider"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="courseValue"
                  :clearable="clearable"
                  :items="COURSES"
                  :loading="courseLoading"
                  item-text="courseName"
                  item-value="id"
                  label="Course"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mb-1" lg4 md4 sm2 xl3 xs1>
              <v-autocomplete
                  v-model="cat2CourseValue"
                  :clearable="clearable"
                  :items="CAT2_COURSES"
                  :loading="cat2CoursesLoading"
                  item-text="courseTitleCat2"
                  item-value="courseTitleCat2"
                  label="Cat 2 Course"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="startDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="endDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:[`item.program.participantsNumber`]="{item}">
          <label for="item">{{ item.program.participantsNumber ? item.program.participantsNumber : "-" }}</label>

        </template>
        <template v-slot:[`item.eventCpdProvider.trainingCenterName`]="{ item }">
          <label for="item">{{
              item.eventCpdProvider ? (item.eventCpdProvider.trainingCenterName ? item.eventCpdProvider.trainingCenterName : null) : "-"
            }}</label>
        </template>
        <template v-slot:[`item.programType.name`]="{ item }">
          <label for="item">{{
              item.programType ? (item.programType.name ? item.programType.name : null) : "-"
            }}</label>
        </template>
        <template v-slot:[`item.category.name`]="{ item }">
          <label for="item">{{
              item.category ? (item.category.name ? item.category.name : null) : "-"
            }}</label>
        </template>
        <template v-slot:[`item.start`]="{ item }">
          <label for="item">{{ item.start ? item.start : "-" }}</label>
        </template>
        <template v-slot:[`item.end`]="{ item }">
          <label for="item">{{ item.end ? item.end : "-" }}</label>
        </template>
        <template v-slot:[`item.trainingTitle`]="{ item }">
          <label for="item">{{ item.trainingTitle ? item.trainingTitle : "-" }}</label>
        </template>
        <template v-slot:[`item.activityDelivery.name`]="{ item }">
          <label for="item">{{
              item.activityDelivery ? item.activityDelivery.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.fundedBy.name`]="{ item }">
          <label for="item">{{
              item.fundedBy ? item.fundedBy.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.program.program_courses`]="{ item }">
          <label v-if="item.program && item.program.program_courses.length !== 0" for="item">
            <span
                v-for="(course, index) in item.program.program_courses"
                :key="index"
                style="display: flex"
            >
              {{
                course.course.courseName ? course.course.courseName : "-"
              }}({{ course.course.continualEducationUnit ? course.course.continualEducationUnit : '-' }})
              <span v-if="index != item.program.program_courses.length - 1">
                ,
              </span>
            </span>
          </label>
        </template>
        <template v-slot:[`item.courseTitleCat2`]="{ item }">
          <label for="item">
            {{ item.courseTitleCat2 ? item.courseTitleCat2 : "-" }}({{ item.ceuCat2 ? item.ceuCat2 : '-' }})
          </label>
        </template>
        <template v-slot:[`item.totalCost`]="{ item }">
          <label for="item">{{ item.totalCost ? item.totalCost : "-" }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {getActivityDeliveries, getCategories, getCourses, getProgramTypes, getUser} from "@/utils/helper";
import {RegistrationReportService} from "./registration-report-service";
import {TrainingCenterService} from '../../TrainingCenter/training_center.service';
import {ProgramService} from "../../Programs/programs.service";

export default {
  data() {
    return {
      search: "",
      registrationReport: [],
      export_fields: {
        "Event CPD Provider": "eventCpdProvider.trainingCenterName",
        "CPD Activity Type": "programType.name",
        "CPD Activity": "category.name",
        "Event Start Date": "start",
        "Event End Date": "end",
        "Training Title": "trainingTitle",
        "Activity Delivery": "activityDelivery.name",
        "Training Organizer": "fundedBy.name",
        "Category 1 Courses(CEU)": {
          field: "program.program_courses",
          callback: (value) => {
            const cat1Course = [];
            value ? value.forEach((element) => {
              const elementConc = element.course.courseName + "(" + element.course.continualEducationUnit + ")";
              cat1Course.push(elementConc);
              return cat1Course;
            }) : null;
            return cat1Course.join(", ");
          },
        },
        "Category 2 Courses": "courseTitleCat2",
        "Partcipant Number": "program.participantsNumber",
        "Total Cost": "totalCost",
      },
      headers: [
        {
          text: "Event CPD Provider",
          value: "eventCpdProvider.trainingCenterName"
        },
        {
          text: "CPD Activity Type",
          value: "programType.name"
        },
        {
          text: "CPD Activity",
          value: "category.name"
        },
        {text: "Event Start Date", value: "start"},
        {text: "Event End Date", value: "end",},
        {text: "Training Title", value: "trainingTitle",},
        {text: "Activity Delivery", value: "activityDelivery.name",},
        {text: "Training Organizer", value: "fundedBy.name",},
        {
          text: "Category 1 Courses(CEU)",
          value: "program.program_courses",
          filter: (value) => {
            this.selected = [];
            if (this.courseValue == null || this.courseValue == "") return true;
            return value ? value.find((e) => e.course.courseName == this.courseValue) : null;
          },
        },
        {text: "Category 2 Courses(CEU)", value: "courseTitleCat2",},
        {text: "Participant Number", value: "program.participantsNumber"},

        {
          text: "Total Cost",
          value: "totalCost",
        },
      ],
      loading: false,
      programTypeValue: null,
      PROGRAM_TYPES: [],
      PROGRAM_TYPEID: null,
      CPD_PROVIDERS: [],
      clearable: true,
      cpdProviderValue: null,
      courseValue: null,
      selected: [],
      CATEGORIES: [],
      cpdALoading: false,
      cpdActivityValue: null,
      programTypeLoading: false,
      cpdProviderLoading: false,
      courseLoading: false,
      COURSES: [],
      CAT2_COURSES: [],
      cat2CoursesLoading: false,
      cat2CourseValue: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      ACTIVITY_DELIVERIES: [],
      activityDeliveryLoading: false,
      activityDeliveryValue: null,


      startDateValue: null,
      endDateValue: null,
    };
  },
  async beforeMount() {
    this.loading = true;
    this.programTypeLoading = true;
    this.cpdALoading = true;
    this.cpdProviderLoading = true;
    this.courseLoading = true;
    this.cat2CoursesLoading = true;
    this.activityDeliveryLoading = true;
    this.fetchRegistrationReports();
    this.loading = false;
    this.PROGRAM_TYPES = await getProgramTypes();
    this.programTypeLoading = false;
    const trainingCenterResp = await TrainingCenterService.getAllTrainingCenters();
    this.CPD_PROVIDERS = trainingCenterResp.data.rows;
    this.cpdProviderLoading = false;
    this.CATEGORIES = await getCategories();
    this.cpdALoading = false;
    const courseResp = await getCourses();
    this.COURSES = courseResp.filter(course => {
      return course.isAccredited == true
    })
    this.courseLoading = false;
    const cpdActRes = await ProgramService.getPrograms();

    if (cpdActRes.status === 200) {
      this.loading = false;
      this.CAT2_COURSES = cpdActRes.data.rows.filter((data) => {
        return data.category ? data.category.categoryType == "CAT2" : null;
      });
    } else {
      this.loading = false;
      this.$toast.error(
          "There was a problem fetching CPD Activity, Please try Again!"
      );
    }
    this.cat2CoursesLoading = false;
    this.ACTIVITY_DELIVERIES = await getActivityDeliveries();
    this.activityDeliveryLoading = false;
  },
  computed: {
    canViewRegistration() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Registration Report"
      );
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchRegistrationReports();
      },
      deep: true,
    },
    programTypeValue: function (val) {
      this.programTypeValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
    activityDeliveryValue: function (val) {
      this.activityDeliveryValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
    cpdActivityValue: function (val) {
      this.cpdActivityValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
    cpdProviderValue: function (val) {
      this.cpdProviderValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
    cat2CourseValue: function (val) {
      this.cat2CourseValue = val;
      this.fetchRegistrationReports();
    },
    courseValue: function (val) {
      this.courseValue = val;
      this.fetchRegistrationReports();
    },
    startDateValue: function (val) {
      this.startDateValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
    endDateValue: function (val) {
      this.endDateValue = val == '' ? null : val;
      this.fetchRegistrationReports();
    },
  },
  methods: {
    async fetchRegistrationReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}&`);

      this.programTypeValue !== null && (searchParams += `programTypeId= ${this.programTypeValue}&`);
      this.activityDeliveryValue !== null && (searchParams += `activityDeliveryId= ${this.activityDeliveryValue}&`);
      this.cpdActivityValue !== null && (searchParams += `programId= ${this.cpdActivityValue}&`);
      this.cpdProviderValue !== null && (searchParams += `eventCpdProviderId= ${this.cpdProviderValue}&`);
      this.cat2CourseValue !== null && (searchParams += `courseTitleCat2= ${this.cat2CourseValue}&`);
      this.courseValue !== null && (searchParams += `courseId=${this.courseValue}&`);
      this.startDateValue !== null && (searchParams += `startDate=${this.startDateValue}&`);
      this.endDateValue !== null && (searchParams += `endDate=${this.endDateValue}&`);
      searchParams = searchParams.slice(0, -1);

      const res = await RegistrationReportService.getRegistrationReportstWP(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.registrationReport = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching registration reports, Please try Again!"
        );
      }
    },
  },
};
</script>


<style scoped>
.addCard {
  background: hsla(0, 0%, 100%, 0.45);
}
</style>